import { useEffect } from 'react';
import { useAuthStore } from '../store/auth';
import { useLocale, type Locale } from '../i18n';

function isLocale(s: string | undefined | null): s is Locale {
  return s === 'ru' || s === 'en';
}

// ANX-036 — применяет язык, сохранённый у оператора на backend, поверх
// локального localStorage при login/refresh. Так выбор языка переезжает
// между устройствами: на новом устройстве localStorage пуст (или со старым
// значением), а session.operator.locale несёт актуальный preference с сервера.
//
// Ручная смена в SettingsPage сама обновляет и i18n, и session.operator.locale
// синхронно, поэтому этот эффект на неё не реагирует (значения уже совпадают)
// и не «отыгрывает» выбор назад.
export function useServerLocaleSync(): void {
  const serverLocale = useAuthStore((s) => s.session?.operator.locale);
  const [locale, setLocale] = useLocale();

  useEffect(() => {
    if (isLocale(serverLocale) && serverLocale !== locale) {
      setLocale(serverLocale);
    }
  }, [serverLocale, locale, setLocale]);
}
